import { dateRangeFromISO, getDateRange } from "@app/lib/date-range";
import BooksPage, { booksQuery } from "@app/pages/books/books-page";
import type { booksPage_Query } from "@app/queries/booksPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/books")({
  loader: () =>
    loadQuery<booksPage_Query>(
      environment,
      booksQuery,
      { from: dateRangeFromISO(getDateRange()) ?? undefined },
      { fetchPolicy: "store-or-network" }
    ),
  head: () => pageHead("Books"),
  component: BooksRoute,
});

function BooksRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading the books</div>}
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Building the books...</div>}
      >
        <BooksPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
